import React from "react";
import { formatDayLabel, formatNumber, heatIntensity } from "../selectors";

/**
 * One cell per day of the window, shaded by that day's volume relative to the
 * client's own busiest day. Answers "did they show up every day or once?" —
 * the question a raw total can't.
 *
 * Intensity is per-row on purpose: scaled globally, every client but the
 * largest would be an undifferentiated pale block.
 */
export function DayHeatStrip({ points, metric = "accesses", metricLabel = "accesses" }) {
  const values = (points || []).map((point) => Number(point[metric]) || 0);
  const max = Math.max(0, ...values);

  if (!points?.length) return <span className="ct-spark-empty">—</span>;

  return (
    <div className="ct-heat" role="img" aria-label={`Daily ${metricLabel}`}>
      {points.map((point, index) => {
        const intensity = heatIntensity(values[index], max);
        return (
          <span
            key={point.day}
            className={`ct-heat-cell${intensity === 0 ? " ct-heat-cell--empty" : ""}`}
            style={intensity > 0 ? { opacity: 0.28 + intensity * 0.72 } : undefined}
            title={`${formatDayLabel(point.day)} · ${formatNumber(values[index])} ${metricLabel}`}
          />
        );
      })}
    </div>
  );
}
